<template>
    <CommonChart
        :data="data"
        :config="chartConfig"
        :customers="customers"
        :selectedPeriod="selectedPeriod"
        :customerDataField="'usage'"
        containerClass="chart-container"
    />
</template>

<script>
import CommonChart from "../common/CommonChart.vue";
import { formatEnergyUsage } from "../../utils/energyUtils.js";

export default {
    name: "DashboardUsageTrendChart",
    components: {
        CommonChart,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        customers: {
            type: Array,
            default: () => [],
        },
        selectedPeriod: {
            type: String,
            default: "monthly",
        },
    },
    computed: {
        chartConfig() {
            return [
                {
                    name: "전체 사용량",
                    type: "bar",
                    dataField: "totalUsage",
                    color: "#cbd5e1",
                    borderRadius: [10, 10, 0, 0],
                    yAxis: {
                        name: "사용량",
                        formatter: (value) => {
                            return formatEnergyUsage(value);
                        },
                    },
                    barWidth: "60%",
                },
            ];
        },
    },
};
</script>

<style scoped>
.chart-container {
    width: 100%;
    height: 100%;
    min-height: 0;
    min-width: 0;
}
</style>
